module.exports = __webpack_public_path__ + "img/9600.555844d2.jpg";